import { render, staticRenderFns } from "./EmployerStaticContents.vue?vue&type=template&id=40d30edf&"
import script from "./EmployerStaticContents.vue?vue&type=script&lang=js&"
export * from "./EmployerStaticContents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports